import type { EditableCallback } from 'ag-grid-community';

import { Status } from '../../../../../../types';
import type { DailyTasksGridContext } from '../types';

export const editableStatus: EditableCallback = (params) => {
  const { context, data } = params;
  const { permissions, currentUser } = context as DailyTasksGridContext;
  const { canUpdateOperationalTask, canUpdateResolvedOperationalTask, canUpdateAllOperationalTask } = permissions;
  const { id: currentUserId } = currentUser;

  if (!canUpdateOperationalTask) {
    return false;
  }

  if (data.status === Status.RESOLVED && !canUpdateResolvedOperationalTask) {
    return false;
  }

  if (!canUpdateAllOperationalTask) {
    const responsibleChangeStatus = data.responsible?.id === currentUserId;

    if (!responsibleChangeStatus) {
      return false;
    }
  }

  return true;
};
